module.exports = __webpack_public_path__ + "media/components/assets/icons/default_profile-8e85addc1c0df3235ce2924ad9162ca2.svg";